import { RootState } from 'models';

const getTab = (state: RootState) => state.normalizer.location.tab;

const getDashboardDiskCount = (state: RootState) => state.normalizer.dashboard.disk.count;

const getDashboardDiskStatus = (state: RootState) => state.normalizer.dashboard.disk.status;

const getMonitorMailRows = (state: RootState) => state.normalizer.monitor.mail.mainTableRows;

const getMonitorMailHistory = (state: RootState) => state.normalizer.monitor.mail.historyTableRows;

const getSelectedMonitorRow = (state: RootState) => state.normalizer.monitor.selectedRow;

const getDiskMonitor = (state: RootState) => state.normalizer.monitor.disk.mainTableRows;

const getDocumentHistory = (state: RootState) => state.normalizer.monitor.disk.historyTableRows;

const getUploadMonitor = (state: RootState) => state.normalizer.monitor.upload.mainTableRows;

const getDocumentHistoryUpload = (state: RootState) => state.normalizer.monitor.upload.historyTableRows;

const getSelectedErrorRows = (state: RootState) => state.normalizer.monitor.error.errorRow;

const getMonitorMailWfHistory = (state: RootState) => state.normalizer.monitor.mail.wfHistoryTableRows;

const getMonitorDiskWfHistory = (state: RootState) => state.normalizer.monitor.disk.wfHistoryTableRows;

const getMonitorUploadWfHistory = (state: RootState) => state.normalizer.monitor.upload.wfHistoryTableRows;

const getMonitorEinvoiceWfHistory = (state: RootState) => state.normalizer.monitor.eInvoice.wfHistoryTableRows;

const getEInvoiceMonitor = (state: RootState) => state.normalizer.monitor.eInvoice.mainTableRows;

const getDocumentHistoryEInvoice = (state: RootState) => state.normalizer.monitor.eInvoice.historyTableRows;

export default {
  getTab,
  getDashboardDiskCount,
  getDashboardDiskStatus,
  getMonitorMailRows,
  getMonitorMailHistory,
  getSelectedMonitorRow,
  getDiskMonitor,
  getDocumentHistory,
  getDocumentHistoryUpload,
  getUploadMonitor,
  getSelectedErrorRows,
  getMonitorMailWfHistory,
  getMonitorDiskWfHistory,
  getMonitorUploadWfHistory,
  getEInvoiceMonitor,
  getMonitorEinvoiceWfHistory,
  getDocumentHistoryEInvoice,
};
